export default [
  [`Размеры`, `S`, `M`, `L`, `XL`, `2XL`],
  [`Ширина изделия на уровне груди`, `42`, `44`, `46`, `49`, `51`],
  [`Длина изделия по переду`, `65`, `67`, `69`, `71`, `73`],
  [`Ширина переда, 12см от низа изделия`, `54`, `56`, `60`, `64`, `68`],
  [`Длина рукава`, `12`, `14`, `15`, `16`, `17`],
  [`Ширина рукава по низу`, `15`, `16`, `17`, `19`, `21`]
];
